const locale = {
  region: '大区',
  city: '城市',
  zone: '区域',
  searchCityPlaceholder: '搜索{city}',
  searchZonePlaceholder: '搜索{city}或{zone}',
  result: '条结果',
  sale: '促销',
  off: '减价 {}%',
  stockLimited: '库存较少',
  filterLabel: '筛选',
  filterTagAll: '所有',
  noData: '无数据',
  noDataTips1: '暂无匹配搜索和筛选条件的{zone}。',
  noDataTips2: '您可以',
  noDataTips3: '查看所有',
  noDataTips4: '来尝试其他{zone}。'
};
export default locale;